let currentSession = null;
let fetchingPromise = null;

const SAFETY_MARGIN_SECONDS = 60;

// Função que chama sua API GET /session/rekognition
async function fetchNewSession(tokenLink) {
  const res = await fetch(`${process.env.REACT_APP_URL_API}/session/rekognition`, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
      "x-Token": tokenLink,
    },
  });

  if (!res.ok) {
    throw new Error("Falha ao obter sessão do Rekognition");
  }

  const json = await res.json();
  const ret = json.retorno;

  return {
    accessKeyId: ret.AccessKeyId,
    secretAccessKey: ret.SecretAccessKey,
    sessionToken: ret.SessionToken,
    expiration: new Date(ret.Expiration),
  };
}

function isSessionValid(session) {
  if (!session) return false;
  const now = new Date();
  const exp = new Date(session.expiration);
  const diffSeconds = (exp.getTime() - now.getTime()) / 1000;

  return diffSeconds > SAFETY_MARGIN_SECONDS;
}

export async function getValidSession(tokenLink) {
  if (isSessionValid(currentSession)) {
    return currentSession;
  }

  if (!fetchingPromise) {
    fetchingPromise = fetchNewSession(tokenLink)
      .then((session) => {
        currentSession = session;
        return session;
      })
      .finally(() => {
        fetchingPromise = null;
      });
  }

  return fetchingPromise;
}
